import AmountCellItem from './amount_cell_item'

export default AmountCellItem
